import { render, staticRenderFns } from "./TaskNotes.vue?vue&type=template&id=2c805059&scoped=true&"
import script from "./TaskNotes.vue?vue&type=script&lang=js&"
export * from "./TaskNotes.vue?vue&type=script&lang=js&"
import style0 from "./TaskNotes.vue?vue&type=style&index=0&id=2c805059&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c805059",
  null
  
)

export default component.exports